import React from "react";
import '../scss/pages/404.scss';
import NotFoundComponent from "../components/Generic/notfound";

const NotFound = () => {
  return <NotFoundComponent />
}

export default NotFound
